import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';

import Checkbox from '../../helpers/Checkbox';

/**
 * Stateless component for showing filter panel.
 *
 * @param props {Object}.
 * @param props.filters {Immutable.Map} Filter data.
 */
const FilterListComponent = ({ filters, capitalizeLabel = true }) => {
  if (!filters || filters.size === 0) {
    return null;
  }

  const filterName = filters.get('name');
  const content = filters.get('filters').map(f => {
    const text = f.get('text');
    const name = f.get('name');
    const checked = f.get('checked', false);

    return (
      <Checkbox
        key={name}
        capitalizeLabel={capitalizeLabel}
        defaultChecked={checked}
        id={name}
        label={text}
        name={name}
        value={name}
      />
    );
  });

  return (
    <div className="mb8">
      <span className="field-label">{filterName}</span>
      {content}
    </div>
  );
};

FilterListComponent.propTypes = {
  capitalizeLabel: PropTypes.bool,
  filters: PropTypes.instanceOf(Map),
};

export const FilterList = memo(FilterListComponent);
